<!--
  创建时间：2024/10/22 下午2:31
  创建人：toyeh
  文件描述：BlockHead
-->

<template>
  <div class="block-head f-b-c">
    <h3 class="block-head-title" :class="icon">{{ title }} <span>{{subtitle}}</span></h3>
  </div>
</template>

<script>
export default {
  name: "BlockHead",
  components: {},
  props: {
    icon: {
      type: String,
      default: "purchase"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped lang="scss">
.block-head{
	width: 100%;
	height: 70px;
	flex-shrink: 0;
	.block-head-title{
		font-size: 30px;
		font-weight: bold;
		color: #333;
		margin-right: 30px;
    span {
      font-weight: 400;
      font-size: 20px;
      color: #999999;
    }
	}
}
</style>
